// Create types
export const TRANSFERTYPE_CREATE_ERROR = 'TRANSFERTYPE_CREATE_ERROR';
export const TRANSFERTYPE_CREATE_LOADING = 'TRANSFERTYPE_CREATE_LOADING';
export const TRANSFERTYPE_CREATE_SUCCESS = 'TRANSFERTYPE_CREATE_SUCCESS';
export const TRANSFERTYPE_CREATE_VIOLATIONS = 'TRANSFERTYPE_CREATE_VIOLATIONS';
export const TRANSFERTYPE_CREATE_RESET = 'TRANSFERTYPE_CREATE_RESET';

// Show types
export const TRANSFERTYPE_SHOW_ERROR = 'TRANSFERTYPE_SHOW_ERROR';
export const TRANSFERTYPE_SHOW_LOADING = 'TRANSFERTYPE_SHOW_LOADING';
export const TRANSFERTYPE_SHOW_RETRIEVED_SUCCESS = 'TRANSFERTYPE_SHOW_RETRIEVED_SUCCESS';
export const TRANSFERTYPE_SHOW_RESET = 'TRANSFERTYPE_SHOW_RESET';

// Update types
export const TRANSFERTYPE_UPDATE_RESET = 'TRANSFERTYPE_UPDATE_RESET';
export const TRANSFERTYPE_UPDATE_UPDATE_ERROR = 'TRANSFERTYPE_UPDATE_UPDATE_ERROR';
export const TRANSFERTYPE_UPDATE_UPDATE_LOADING = 'TRANSFERTYPE_UPDATE_UPDATE_LOADING';
export const TRANSFERTYPE_UPDATE_UPDATE_SUCCESS = 'TRANSFERTYPE_UPDATE_UPDATE_SUCCESS';
export const TRANSFERTYPE_UPDATE_RETRIEVE_ERROR = 'TRANSFERTYPE_UPDATE_RETRIEVE_ERROR';
export const TRANSFERTYPE_UPDATE_RETRIEVE_LOADING = 'TRANSFERTYPE_UPDATE_RETRIEVE_LOADING';
export const TRANSFERTYPE_UPDATE_RETRIEVE_SUCCESS = 'TRANSFERTYPE_UPDATE_RETRIEVE_SUCCESS';
export const TRANSFERTYPE_UPDATE_UPDATE_VIOLATIONS = 'TRANSFERTYPE_UPDATE_UPDATE_VIOLATIONS';

// List types
export const TRANSFERTYPE_LIST_ERROR = 'TRANSFERTYPE_LIST_ERROR';
export const TRANSFERTYPE_LIST_LOADING = 'TRANSFERTYPE_LIST_LOADING';
export const TRANSFERTYPE_LIST_RESET = 'TRANSFERTYPE_LIST_RESET';
export const TRANSFERTYPE_LIST_VIEW = 'TRANSFERTYPE_LIST_VIEW';
export const TRANSFERTYPE_LIST_SUCCESS = 'TRANSFERTYPE_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/transfertype/mutation-types.js